/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Signing_In_Button_2Inputs */



/**
* | output |
* | --- |
* | "Signing In..." |
*
* @param {Login_Signing_In_Button_2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_signing_in_button_2 = /** @type {((inputs?: Login_Signing_In_Button_2Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Signing_In_Button_2Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connexion en cours...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anmelden...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accesso in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вход в систему...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando sesión...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在登录……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サインイン中...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इन कर रहे हैं...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Entrando...")
	return /** @type {LocalizedString} */ ("Signing In...")
});